import { render, staticRenderFns } from "./TarjetaLavadero.vue?vue&type=template&id=a4bdd1e2&scoped=true"
import script from "./TarjetaLavadero.vue?vue&type=script&lang=js"
export * from "./TarjetaLavadero.vue?vue&type=script&lang=js"
import style0 from "./TarjetaLavadero.vue?vue&type=style&index=0&id=a4bdd1e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4bdd1e2",
  null
  
)

export default component.exports